<template>
	<div class="copyright">
		Copyright © {{curYear}} afeefe.com
		&nbsp;
		<img class="beiAnImg" src="@/assets/img/global/beian.png" alt=""/>
		<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32028102001164">苏公网安备32028102001164号</a>
		&nbsp;
		<a target="_blank" href="http://beian.miit.gov.cn">苏ICP备20011698号-1</a>
	</div>
</template>

<script>
export default {
	name: "Copyright",
	data() {
		return {
			curYear: ''
		}
	},
	mounted() {
		let curDate = new Date();
		this.curYear = curDate.getFullYear();
	}
}
</script>

<style scoped>
	.copyright{ width: 100%; position: absolute; bottom: 2px; text-align: center; color: #c1c1c1; font-size: 13px; height: 20px; line-height: 20px; font-family: 'SiYuan-ExtraLight', sans-serif; }
	.beiAnImg{ width: 16px; height: 16px; margin: 0 5px -2px 0; }
	a{ text-decoration: none; transition: all 0.3s linear; color: #c1c1c1; }
	a:hover{ color: #18a6de; }
</style>